<div mat-dialog-title class="dialog-title">
    <h1 class="disable-css">{{'elevator_call_details.callBackTitle' | localize}}</h1>
   
</div>
<hr>
<div mat-dialog-content  class="content_css">
    
    <div *ngIf="connectingString" class="fs-5">{{connectingString}}</div>
    <!-- {{'elevator_call_details.popupHeader' | localize}} -->
    <picture *ngIf="loader">
        <div class="row loading_css">
            <div class="col-md-4" >
                <mat-icon class="call_icon"  > call </mat-icon>
            </div>
            <div class="col-md-4">
                <source media='(min-width:0px)' class="call_image_css" srcset="/assets/img/calling.gif">
                <img  class="call_image_css" mat-card-image src="/assets/img/calling.gif" alt="Loading...">
            </div>
            <div class="col-md-4"  >
                <mat-icon class="elevator_icon" > elevator </mat-icon>
            </div>
        </div>
    </picture>
    <div *ngIf="joining" class="fs-5">{{'elevator_call_details.joining' | localize}}</div>
   

    <div style="margin-top: 50px;   text-align: center; "  *ngIf="!connectingString">
        <div class="fs-5">{{callbackMsg}}</div>
        <div  class="fs-5">{{callbackError}}</div>
    </div>
    <div align="center" style="margin-top: 30px !important;" *ngIf="callbackMsg || callbackError">
        <button mat-raised-button  mat-dialog-close color="primary">{{'avaya_calls.ok' | localize}}</button>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button class="reset_bg" (click)="onDialogCancel()">{{'elevator_call_details.cancel' | localize }}</button>
</div>
